// extracted by mini-css-extract-plugin
export default {"trigger":"Tooltip_trigger__KIo+-","bubble":"Tooltip_bubble__5Cjiu","tooltip-in":"Tooltip_tooltip-in__IxGkq","top":"Tooltip_top__7sh0E","bottom":"Tooltip_bottom__224Yg"};